import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Components
import { WwniSubCategoryComponent } from './components/wwni-sub-category.component';

// Services
import { WwniSubCategoryService } from './services/wwni-sub-category.service';

@NgModule({ declarations: [
        WwniSubCategoryComponent
    ],
    exports: [
        WwniSubCategoryComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule], })
export class WwniSubCategoryModule {
  // Custom element registration moved to AppElementsModule
}
